import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7795228e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "Select App", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "Select Endpoint", -1))
const _hoisted_7 = { class: "d-flex flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "GET", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "POST", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PUT", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PATCH", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "DELETE", -1))
const _hoisted_13 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-dark dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_16 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1",
  style: {"min-width":"500px"}
}
const _hoisted_17 = { class: "dropdown-header" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  style: {"width":"80px"},
  class: "d-inline-block"
}
const _hoisted_20 = { class: "float-end" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<li data-v-7795228e><h6 class=\"dropdown-header\" data-v-7795228e>Assets</h6></li><li data-v-7795228e><a class=\"dropdown-item\" href=\"#\" data-v-7795228e>Action</a></li><li data-v-7795228e><a class=\"dropdown-item\" href=\"#\" data-v-7795228e>Another action</a></li><li data-v-7795228e><a class=\"dropdown-item\" href=\"#\" data-v-7795228e>Something else here</a></li><li data-v-7795228e><hr class=\"dropdown-divider\" data-v-7795228e></li>", 5)
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "Request Body", -1))
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-bolt fa-fw me-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Execute ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_33 = ["rows"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.callData.app) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installedApps, (app, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: app.id
            }, " [" + _toDisplayString(app.id) + "] " + _toDisplayString(_ctx.availableApps[app.app_name].title) + "        " + _toDisplayString(app.clients.map((client) => client.clientName).join(', ')), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.callData.app]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            style: {"width":"140px"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.callData.method) = $event))
          }, _hoisted_13, 512), [
            [_vModelSelect, _ctx.callData.method]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "/api/v1/...",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.callData.endpoint) = $event))
          }, null, 512), [
            [_vModelText, _ctx.callData.endpoint]
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.endpointPresets, (presets, label) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("h6", _hoisted_17, _toDisplayString(label), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presets, (preset, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: label + '_' + idx
                    }, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.setPreset(preset)), ["prevent"])
                      }, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(preset[0]), 1),
                        _createTextVNode(" " + _toDisplayString(preset[1]) + " ", 1),
                        _createElementVNode("small", _hoisted_20, _toDisplayString(preset[2]), 1)
                      ], 8, _hoisted_18)
                    ]))
                  }), 128))
                ], 64))
              }), 128)),
              _hoisted_21
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.callData.body) = $event)),
          rows: "10"
        }, null, 512), [
          [_vModelText, _ctx.callData.body]
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.execute && _ctx.execute(...args)))
        }, _hoisted_31)
      ]),
      (!_ctx.executing && (_ctx.lastResponse.data || _ctx.lastResponse.headers))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastResponse.headers, (value, header) => {
                return (_openBlock(), _createElementBlock("tr", { key: header }, [
                  _createElementVNode("th", null, _toDisplayString(header), 1),
                  _createElementVNode("td", null, _toDisplayString(value), 1)
                ]))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formattedResponseData) = $event)),
              rows: _ctx.formattedResponseData.replace(/[^\n]/g, '').length + 1,
              readonly: ""
            }, null, 8, _hoisted_33), [
              [_vModelText, _ctx.formattedResponseData]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}